import "antd/dist/reset.css";
import "./styles/App.css";
import "./styles/footer.css";
import "mapbox-gl/dist/mapbox-gl.css";
import { Layout } from "antd";
import Router from "./routers/Router";

const { Content } = Layout;

function App() {
  return (
    <Layout className="app-layout">
      <Content className="app-content">
        <Router />
      </Content>
    </Layout>
  );
}

export default App;
